import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { IconStarter, IconBusiness, IconProfessional } from './PlanIcons'
import AuditModal from './AuditModal'

const IconTrue = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0002 15.172L19.1922 5.979L20.6072 7.393L10.0002 18L3.63623 11.636L5.05023 10.222L10.0002 15.172Z" fill="#57007B"/></svg>`

const plansData = {
    "INR": [
        { name: 'STARTER', icon: IconStarter, price: '₹21,000', originalPrice: '₹30,000', extraLabel: 'Add. Per Page', extraCost: '₹2,700' },
        { name: 'BUSINESS', icon: IconBusiness, price: '₹30,000', originalPrice: '₹45,000', extraLabel: 'Add. Per Page', extraCost: '₹3,000', popular: true },
        { name: 'PROFESSIONAL', icon: IconProfessional, price: '₹39,000', originalPrice: '₹57,000', extraLabel: 'Add. Per Page', extraCost: '₹3,300' },
    ],
    "USD": [
        { name: 'STARTER', icon: IconStarter, price: '$296', originalPrice: '$425', extraLabel: 'Add. Per Page', extraCost: '$38' },
        { name: 'BUSINESS', icon: IconBusiness, price: '$424', originalPrice: '$635', extraLabel: 'Add. Per Page', extraCost: '$43', popular: true },
        { name: 'PROFESSIONAL', icon: IconProfessional, price: '$551', originalPrice: '$805', extraLabel: 'Add. Per Page', extraCost: '$47' },
    ]
};

const tableData = [
    { titleText: 'Webpages Development<br>( One page is considered an A4 size. )', col1: '5', col2: '7', col3: '9' },
    { titleText: 'Revisions - Graphic + HTML', col1: '1', col2: '2', col3: '3' },
    { titleText: 'Content Writing', col1: '1', col2: '2', col3: '3' },
    { titleText: 'Image Editing', col1: '10', col2: '14', col3: '18' },
    { titleText: 'HomePage Banners - UpTo', col1: '1', col2: '2', col3: '3' },
    { titleText: 'Responsive Web - Mobile &amp; Tablet Support', col1: '70%', col2: '80%', col3: '90%' },
    { titleText: 'Team Level', col1: 'Skilled', col2: 'Pro', col3: 'Pro' },
    { titleText: 'CTA', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Non Broken Link', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Footer Menu', col1: '-', col2: IconTrue, col3: IconTrue },
    { titleText: 'Social Media Networking Linking', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Finding Free Images Related To Contents', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Dynamic Website', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'SSL Certificate Installation', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Search Facility', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Logo: Fix logo size 145px wide x 52px tall', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Sticky Header Menu', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Google analytics', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Testing / Quality Check', col1: IconTrue, col2: IconTrue, col3: IconTrue },
];

export default function BasicWebPlanTable() {
    const [currency, setCurrency] = useState('INR');
    const [showAuditModal, setShowAuditModal] = useState(false);

    const plans = plansData[currency];

    return (
        <div className="pricing-new cSection">
            <div className="cContainer">
                <div className="pricing-currency-select">
                    <div className="currency-toggle">
                        <button className={currency === 'INR' ? 'active' : ''} onClick={() => setCurrency('INR')}>₹INR</button>
                        <button className={currency === 'USD' ? 'active' : ''} onClick={() => setCurrency('USD')}>$USD</button>
                    </div>
                </div>

                <div className="pricing-unified-wrapper">
                    <table className="pricing-unified-table">
                        <thead>
                            <tr>
                                <th className="features-header">
                                    <h3>Our Plans</h3>
                                    <p>Select the best plan for your needs.</p>
                                </th>
                                {plans.map((plan, idx) => (
                                    <th className={`plan-header ${plan.popular ? 'popular' : ''}`} key={idx}>
                                        <div className="plan-header-content">
                                            {plan.popular && <span className="popular-badge">Popular</span>}
                                            {plan.icon && <div className="plan-icon" dangerouslySetInnerHTML={{ __html: plan.icon }}></div>}
                                            <span className="plan-name">{plan.name}</span>
                                            <div className="plan-price" dangerouslySetInnerHTML={{ __html: plan.price }}></div>
                                            {plan.originalPrice && <div className="plan-price-original">{plan.originalPrice}</div>}
                                            {!plan.originalPrice && <div className="plan-price-original"></div>}
                                            <span className="plan-type">One-time cost</span>
                                            {plan.extraCost && <span className="plan-extra">{plan.extraLabel}: {plan.extraCost}</span>}
                                            <button className="plan-cta" onClick={() => setShowAuditModal(true)}>Get Started</button>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, idx) => (
                                <tr key={idx}>
                                    <td dangerouslySetInnerHTML={{ __html: row.titleText }}></td>
                                    <td className={plans[0]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col1 }}></span></td>
                                    <td className={plans[1]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col2 }}></span></td>
                                    <td className={plans[2]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col3 }}></span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <AuditModal show={showAuditModal} handleClose={() => setShowAuditModal(false)} />

                <div className="pricing-notes">
                    <h4 className="notes-title">Note:-</h4>
                    <ul className="notes-list">
                        <li>The client should provide clear photographs, videos, and content.</li>
                        <li>Once the material is uploaded to the website, any changes will be chargeable afterward.</li>
                        <li>18% GST Tax extra (for Indian customers only).</li>
                        <li>Payment Gateway + Forex cost extra (for international customers only).</li>
                        <li>Domain &amp; Hosting cost is extra (not included in the above pricing).</li>
                        <li>Any additional page or section beyond the plan scope will be charged separately as per the Additional Per Page Cost.</li>
                        <li>Website content &amp; images must be provided by the client before development begins.</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
